import { render, staticRenderFns } from "./Compartilhe.vue?vue&type=template&id=163a1ade&"
import script from "./Compartilhe.vue?vue&type=script&lang=js&"
export * from "./Compartilhe.vue?vue&type=script&lang=js&"
import style0 from "./Compartilhe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports